import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppointmentComponent } from './appointment/appointment.component';
import { AppointmentexitingComponent } from './appointmentexiting/appointmentexiting.component';
import { ExitingpatientloginComponent } from './exitingpatientlogin/exitingpatientlogin.component';
import { FinalappointmentmessageComponent } from './finalappointmentmessage/finalappointmentmessage.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { PatientinsuranceComponent } from './patientinsurance/patientinsurance.component';
import { PatientpaymenttypeComponent } from './patientpaymenttype/patientpaymenttype.component';
import { PaymentFailedComponent } from './payment-failed/payment-failed.component';
import { PaymentOverviewComponent } from './payment-overview/payment-overview.component';
import { PaymentComponent } from './payment/payment.component';
import { ThankyoumessageonappointmentComponent } from './thankyoumessageonappointment/thankyoumessageonappointment.component';
import { RegistrationConsentFormComponent } from './registration-consent-form/registration-consent-form.component';
import { RegistrationFinancialFormComponent } from './registration-financial-form/registration-financial-form.component';
//import { CheckinComponent } from './checkin/checkin.component';
import { ReferralCheckinComponent } from './referral-checkin/referral-checkin.component';
import { ReferralComponent } from './referral/referral.component';
import { StandAloneSchedulerComponent } from './standAloneScheduler/standalonescheduler.component';
import { LabComponent } from './lab/lab.component';
import { AfterVisitSurveyComponent } from './after-visit-survey/after-visit-survey.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: 'appointment',
    component: AppointmentComponent
  },
  {
    path: 'insurance',
    component: PatientinsuranceComponent
  },
  {
    path: 'pay_type',
    component: PatientpaymenttypeComponent
  },
  {
    path: 'payment-overview',
    component: PaymentOverviewComponent
  },
  {
    path: 'payment',
    component: PaymentComponent
  },
  {
    path: 'payment-error',
    component: PaymentFailedComponent
  },
  {
    path: 'securelogin',
    component: ExitingpatientloginComponent
  },
  {
    path:'exitingappointment',
    component:AppointmentexitingComponent
  },
  {
    path:'appoin-mes',
    component : FinalappointmentmessageComponent
  },
  {
    path:'thank-app',
    component:ThankyoumessageonappointmentComponent
  },
  {
    path: 'registration-consent-form',
    component: RegistrationConsentFormComponent
  },
  {
    path: 'registration-financial-form',
    component: RegistrationFinancialFormComponent
  },
  //{
  //  path: 'checkin',
  //  component: CheckinComponent
  //},
    {
    path: 'preferral',
      component: ReferralCheckinComponent
  },
    {
    path: 'referral',
      component: ReferralComponent
  },
    {
    path: 'scheduler',
      component: StandAloneSchedulerComponent
  },
  {
    path: 'plab',
  component: LabComponent
  },
  {
    path: 'after-visit-survey',
    component: AfterVisitSurveyComponent
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RegistrationRoutingModule { }
